<div class="container-fluid page">
    <div class="d-flex page__box p-3 mt-2">À Propos</div>
    <div class="page__content shadow p-3 position-relative">
        <div class="page__content-data position-absolute text-center">
            About Content Goes Here
        </div>
    </div>
</div>